import { formatUIDateTime } from 'utils/helpers'

export const toTableRowItems = items =>
  items.map(item => ({
    id: item.id,
    status: item.status || '',
    statusValue: item.statusValue || '',
    createdBy: item.createdBy || '',
    created: formatUIDateTime(item.created),
    updatedBy: item.updatedBy || '',
    updated: formatUIDateTime(item.updated),
    processType: item.processType || '',
    counter: item.counter === '' ? '0' : item.counter,
    truckNumber: item.truckNumber || ''
  }))
